import { formatDate } from '@angular/common';

import { DataFilterDateRange, TripFilterDateRange } from '@fcom/common/interfaces';

const DATE_FORMAT = 'yyyy-MM-dd';
const API_LOCALE = 'en';

export const getDateRange = (dateFilter: DataFilterDateRange, date: Date): TripFilterDateRange => {
  switch (dateFilter) {
    case DataFilterDateRange.LAST_YEAR: {
      return {
        fromDate: formatDate(
          new Date(date.getFullYear() - 1, date.getMonth(), date.getDate()),
          DATE_FORMAT,
          API_LOCALE
        ),
        toDate: formatDate(date, DATE_FORMAT, API_LOCALE),
      };
    }
    case DataFilterDateRange.LAST_SIX_MONTHS: {
      return {
        fromDate: formatDate(new Date(date.getFullYear(), date.getMonth() - 6, 1), DATE_FORMAT, API_LOCALE),
        toDate: formatDate(date, DATE_FORMAT, API_LOCALE),
      };
    }
    case DataFilterDateRange.YEAR_TO_DATE:
    default: {
      return {
        fromDate: formatDate(new Date(date.getFullYear(), 0, 1), DATE_FORMAT, API_LOCALE),
        toDate: formatDate(date, DATE_FORMAT, API_LOCALE),
      };
    }
  }
};
